import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { IMaintenanceModeResponse } from 'modules/maintenance/types';

export const maintenanceModeRequest = async (userEmail: string): Promise<IMaintenanceModeResponse> => {
  const response: AxiosResponse<IMaintenanceModeResponse> = await getApi().get(`SystemStatus/Get/${userEmail}`);
  return response.data;
};
